module.exports = require("npm:inherits@2.0.1/inherits_browser.js");